module.exports = __webpack_public_path__ + "assets/img/img-exam-result.0ec31d48.png";